<template>
  <div id="app">
    <template v-if="menu">
      <div class="header-menu">
        <h1>МЕНЮ</h1>
        <button class="btn-link" @click="menu=!menu">
          <svg width="61" height="60" viewBox="0 0 61 60" fill="none" xmlns="http://www.w3.org/2000/svg">
            <line x1="1.35355" y1="0.646447" x2="60.3536" y2="59.6465" stroke="#C4C4C4"/>
            <line x1="0.646447" y1="59.6464" x2="59.6465" y2="0.646443" stroke="#C4C4C4"/>
          </svg>
        </button>
      </div>
      <div class="mob-menu">
        <router-link to="/">ГОЛОВНА</router-link>
        <router-link to="/reports">ЗВІТИ</router-link>
        <router-link to="/docs">ДОКУМЕНТООБІГ</router-link>
        <router-link to="/card">КАРТКА</router-link>
        <router-link to="/maps">МАПА</router-link>
        <router-link to="/manuals">ІНСТРУКЦІЇ</router-link>
        <a class="hover-logout" @click="logout">Вихід</a>
      </div>

    </template>
    <div class="header-mob" v-if="!menu && isLoggedIn">
      <div class="links-mob">
        <a class="usr-link">
          <svg class="usr-icon" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.05 18"><defs></defs><title>user grey</title><path class="cls-1" d="M15.43,2.64a9,9,0,0,0-12.76,0,9,9,0,0,0,0,12.72,9,9,0,0,0,12.76,0,9,9,0,0,0,0-12.72ZM4.55,15.55a4.57,4.57,0,0,1,9,0,7.93,7.93,0,0,1-9,0ZM6.18,7.87a2.87,2.87,0,1,1,2.87,2.86A2.87,2.87,0,0,1,6.18,7.87Zm8.29,7a5.62,5.62,0,0,0-1.65-2.64,5.69,5.69,0,0,0-1.63-1,3.93,3.93,0,1,0-4.28,0,5.74,5.74,0,0,0-1.64,1,5.68,5.68,0,0,0-1.64,2.64A8,8,0,1,1,17,9a7.93,7.93,0,0,1-2.55,5.82Zm0,0" transform="translate(-0.02 0)"/></svg>
          {{$store.state.user}}</a>
        <ul class="dropdown-child">
          <li>
            <router-link to="/history-messages">Історія повідомлень</router-link>
          </li>
        </ul>
      </div>
    </div>

    <template v-if="!menu">
      <div id="nav" v-if="isLoggedIn">
        <router-link class="logo-menu-link" to="/"><img class="logo-menu" alt="SvitPro logo" src="./assets/logo.png"></router-link>
        <router-link class="logo-menu-link-mob" to="/"><img class="logo-mb-menu" alt="SvitPro logo" src="./assets/logo-mobile.png"></router-link>

        <button class="btn-link" @click="menu=!menu"><svg class="menu-mb" width="60" height="48" viewBox="0 0 60 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="0.5" width="59" height="47" fill="white" stroke="#C4C4C4"/>
          <line x1="15" y1="13.5" x2="43" y2="13.5" stroke="#C4C4C4"/>
          <line x1="15" y1="23.5" x2="43" y2="23.5" stroke="#C4C4C4"/>
          <line x1="15" y1="33.5" x2="43" y2="33.5" stroke="#C4C4C4"/>
        </svg></button>



        <div class="router">
          <router-link to="/">
            <svg class="home-icon" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 17.87"><defs></defs><title>home grey</title><path class="cls-1" d="M15,18H3a1.62,1.62,0,0,1-1.61-1.62V6.87a.56.56,0,1,1,1.12,0v9.51a.49.49,0,0,0,.49.49H15a.49.49,0,0,0,.49-.49V6.87a.56.56,0,0,1,1.12,0v9.51A1.62,1.62,0,0,1,15,18Zm0,0" transform="translate(0 -0.13)"/><path class="cls-1" d="M17.44,8.84a.55.55,0,0,1-.4-.16l-7-7A1.48,1.48,0,0,0,8,1.68l-7,7a.57.57,0,0,1-.8,0,.59.59,0,0,1,0-.8l7-7a2.6,2.6,0,0,1,3.68,0l7,7a.59.59,0,0,1,0,.8.57.57,0,0,1-.4.16Zm0,0" transform="translate(0 -0.13)"/><path class="cls-1" d="M11.25,18H6.75a.56.56,0,0,1-.56-.56v-6A1.75,1.75,0,0,1,8,9.69h2.1a1.75,1.75,0,0,1,1.76,1.75v6a.56.56,0,0,1-.56.56ZM7.31,16.87h3.38V11.44a.64.64,0,0,0-.64-.63H8a.64.64,0,0,0-.64.63Zm0,0" transform="translate(0 -0.13)"/></svg>
            <span>ГОЛОВНА</span>
          </router-link>
          <div class="links">
            <a>ЗВІТИ</a>
            <ul class="dropdown-child">
              <li>
                <router-link to="/service-results">Обіг по клієнту</router-link>
              </li>
              <li>
                <router-link to="/limits">Стан лімітів</router-link>
              </li>
              <li v-if="$store.state.schemeType !== 0">
                <router-link  to="/digital-wallets">Електроний Гаманець</router-link>
              </li>
            </ul>
          </div>
          <router-link to="/docs">ДОКУМЕНТООБІГ</router-link>
          <router-link to="/card">КАРТКА</router-link>
          <router-link to="/maps">МАПА</router-link>
          <router-link to="/manuals">ІНСТРУКЦІЇ</router-link>
        </div>
        <div class="user">
          <div class="links">
            <a class="usr-link">
              <svg class="usr-icon" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.05 18"><defs></defs><title>user grey</title><path class="cls-1" d="M15.43,2.64a9,9,0,0,0-12.76,0,9,9,0,0,0,0,12.72,9,9,0,0,0,12.76,0,9,9,0,0,0,0-12.72ZM4.55,15.55a4.57,4.57,0,0,1,9,0,7.93,7.93,0,0,1-9,0ZM6.18,7.87a2.87,2.87,0,1,1,2.87,2.86A2.87,2.87,0,0,1,6.18,7.87Zm8.29,7a5.62,5.62,0,0,0-1.65-2.64,5.69,5.69,0,0,0-1.63-1,3.93,3.93,0,1,0-4.28,0,5.74,5.74,0,0,0-1.64,1,5.68,5.68,0,0,0-1.64,2.64A8,8,0,1,1,17,9a7.93,7.93,0,0,1-2.55,5.82Zm0,0" transform="translate(-0.02 0)"/></svg>
              {{$store.state.user}}</a>
            <ul class="dropdown-child">
              <li>
                <router-link to="/history-messages">Історія повідомлень</router-link>
              </li>
            </ul>
          </div>
          <div class="logout">
            <a class="hover-logout" v-tooltip.top-center="'Вихід'" @click="logout">
              <svg class="usr-icon" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.94 18"><defs></defs><title>exit grey</title><path class="cls-1" d="M0,16.4V1.6A1.6,1.6,0,0,1,1.63,0H8.07a.56.56,0,0,1,.56.56.56.56,0,0,1-.56.55H1.63a.49.49,0,0,0-.49.49V16.4a.49.49,0,0,0,.49.49H8.07a.56.56,0,1,1,0,1.11H1.63A1.6,1.6,0,0,1,0,16.4Zm0,0" transform="translate(-0.03)"/><path class="cls-1" d="M11.11,8.56H3.17a.57.57,0,0,0,0,1.13h7.94a.57.57,0,0,0,0-1.13Z" transform="translate(-0.03)"/><path class="cls-1" d="M11.68,8.6l-1.3-.76h0L8.27,6.63a.56.56,0,0,0-.77.2.57.57,0,0,0,.21.77L9.88,8.86h0l1.24.71a.56.56,0,0,0,.77-.2A.57.57,0,0,0,11.68,8.6Z" transform="translate(-0.03)"/><path class="cls-1" d="M11.12,8.63l-1.31.75h0L7.71,10.6a.57.57,0,0,0-.21.77.56.56,0,0,0,.77.2l2.17-1.25h0l1.24-.72a.57.57,0,0,0,.21-.77A.56.56,0,0,0,11.12,8.63Z" transform="translate(-0.03)"/></svg>
            </a>
          </div>
        </div>
      </div>
      <div class="breadcrumbs" v-if="$route.name!=='Home' && $route.name!=='TranceShow'  && $route.name!=='TranceShowTablet' && isLoggedIn">
        <breadcrumbs></breadcrumbs>
      </div>
      <router-view/>
      <div class="footer" v-if="isLoggedIn">
        <div class="info">
          <p>Інформація про вартість отриманих послуг, наявна у системі,<br> не є фіскальною та може використовуватися лише для оцінки та планування витрат.</p>
        </div>
        <div class="contact">
          <p>Якщо у Вас виникли будь-які питання щодо використання сервісів, Вам допоможе <br> особистий менеджер по тел.:
            <a href="tel:+380442295290">(044) 229-52-90</a>, e-mail: <a href="mailto:office@svitpro.com.ua">office@svitpro.com.ua</a></p>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  computed : {
    isLoggedIn : function(){ return this.$store.getters.isLoggedIn}
  },
  created: function () {

  },
  data() {
    return {
      menu: false
    }
  },
  watch: {
    $route: function (){
      this.menu = false;
    }
  },
  methods: {
    logout: function () {
      this.$store.dispatch('logout')
          .then(() => {
            this.$router.push('/login')
          })
    }
  },
}
</script>
<style>

.header-menu {
  display: flex;
  justify-content: space-between;
  margin: 34px;

  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 25px;
  line-height: 40px;
  /* or 160% */

  font-feature-settings: 'cpsp' on;

  color: #222160;

}
.mob-menu {
  display: flex;
  flex-direction: column ;
  margin-left: 34px;
}
.mob-menu a {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 25px;
  line-height: 50px;
  /* or 200% */
  font-feature-settings: 'cpsp' on;
  color: #222160;
  text-transform: uppercase;
}
.mob-menu a:last-child {
  margin-top: 50px;
}
.btn-link {
  background: none;
  border: none;
}
.logout {
  height: 28px;
}
:root {
  --main-blue:  #222160;
  --strong-grey: #C4C4C4;
  --middel-grey: #E5E5E5;
  --soft-grey: #F5F5F5;
  --soft-purple: #4E4CC7;
  --active-purple: #DCDBF4;
  --general-green: #00A8B7;
  --usual-black: #000000;
  --toltip-grey: #f9f9f9;
  --usual-white: #FFFFFF;
  --red-notice:  #FD0404;
}
body, html {
  height: 100%;
//position: relative;
  margin: 0;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 17px;
  cursor: var(--usual-black);
  box-sizing: border-box;
}
.main-title {
  text-align: left;
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 30px;
  line-height: 19px;
  /* identical to box height, or 63% */
  color: var(--main-blue);

}

h2.swal2-title {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 19px;
  /* or 95% */
  text-transform: uppercase;
  font-feature-settings: 'cpsp' on;
  color: var(--soft-purple);
  margin-bottom: 25px;
}
div.swal2-popup.swal2-modal.swal2-show {

  padding: 67px 44px;
  border-radius: 15px;
}
div.swal2-html-container{
  height: 100%;
  overflow: hidden;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 19px;
  /* or 95% */
  font-feature-settings: 'cpsp' on;
  color: var(--usual-black);
  margin: 0;
}
.text-align-end{
  text-align: end;
}
.text-align-center {
  text-align: center;
}
button.swal2-close {
  position: absolute;
  top: 17px;
  right: 18px;
  width: 22px;
  height: 22px;
}
.swal2-confirm {
  width: 145px!important;
  height: 40px!important;
  border-radius: 20px!important;
  border: none!important;
  background-color: var(--main-blue);
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 13px;
  line-height: 19px;
  /* identical to box height, or 146% */

  text-align: center;
  text-transform: uppercase;
  font-feature-settings: 'cpsp' on;

  color: var(--usual-white);

}
.swal2-confirm:focus-visible { outline: none; }
#app {
  display: flex;
  flex-direction: column;
  //align-items: center;
  justify-content: space-between;
  height: 100%;
}
.usr-icon {
  width: 28px;
  height: 28px;
  //top: 8px;
  //margin-left: 83px;
  margin-right: 8px;
  fill: var(--strong-grey);
  //padding-bottom: 3px;
}
.usr-icon:hover {
  fill: var(--soft-purple);
}
.usr-link:hover svg {
  fill: var(--soft-purple);
}

#nav a.usr-link {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 19px;
  /* identical to box height, or 146% */
  //letter-spacing: 1px;
  //text-transform: lowercase;
  text-align: center;
  margin-right: 19px!important;
  color: var(--main-blue);
  display: flex;
  align-items: center;
  cursor: pointer;
}
.router-link-exact-active .home-icon {
  fill: var(--soft-purple);
}
.home-icon {
  //top: 10px;
  width: 28px;
  height: 28px;
  //padding-right: 4px;
  fill: var(--strong-grey);
  margin-right: 5px;
}
.home-icon
.logo-menu {
  width: 179px;
  height: 50px;
  top: -4px;
  //margin-left: 150px;
  //margin-right: 92px;
}
#nav {
  margin-top: 30px;
  margin-bottom: 35px;
  margin-left: auto;
  margin-right: auto;
  width: 80%; /*1139px;*/
  display: flex;
  justify-content: space-between;
}
.breadcrumbs{
  margin-left: auto;
  margin-right: auto;
  //margin-bottom: 48px;
  width: 80%; /*1139px;*/
  display: flex;
  justify-content: space-between;
}
.breadcrumbs ol.breadcrumb {
  display: flex;
  list-style: none;
  padding: 0;
}
.breadcrumb-item span {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 20px;
  /* or 182% */

  font-feature-settings: 'cpsp' on;

  color: var(--main-blue);
  cursor: none;

}
.breadcrumb-item a {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 20px;
  /* or 182% */

  font-feature-settings: 'cpsp' on;

  color: var(--main-blue);

}
.breadcrumb-item {
  border-left: 1px solid var(--middel-grey);
  margin-right: 10px;
  padding-left: 10px;
}
.breadcrumbs > ol > li:nth-child(1) {
  border: none;
  padding-left: 0px;
}
.router{
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
}
.user{
  display: flex;
  align-items: center;
}
#nav a {
  //padding-top: 17px;
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 13px;
  line-height: 19px;
  /* identical to box height, or 146% */
  font-feature-settings: 'cpsp' on;
  color: var(--main-blue);
  margin-right: 15px;
  text-decoration: none;
  letter-spacing: 1px;
  display: flex;
  align-items: center;
}
#nav > div.router > div > ul > li > a {
  letter-spacing: 0;
}
#nav a:hover {
  color: var(--soft-purple);
}
#nav a:hover svg {
  fill: var(--soft-purple);
}
.links li {
  list-style-type: none;
  padding: 5px;
  border-top: 1px solid #C4C4C4;
}
.dropdown-child {
  display: none;
  position: absolute;
  //margin-left: 36px;
  padding-left: 0;
  padding-top: 10px;
  border-bottom:  1px solid #C4C4C4;
  margin: 0;
  background-color: #FFFFFF;
}
.links:hover .dropdown-child{
  display: block;
}
#nav a.router-link-exact-active {
  color: var(--soft-purple);
}
a {
  color: var(--main-blue);
  text-decoration: none;
}
a:hover {
  color: var(--soft-purple);
}
.footer {
  background: rgba(196, 196, 196, 0.3);
  min-height: 90px;
  max-height: 150px;
  height: auto;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  flex-wrap: wrap;
  margin-top: 53px;
  //height: 100%;
}
.info{
  //margin-left: 78px;
  margin-top: 22px;
  margin-bottom: 24px;
  width:  40%;/*573px;*/
}
.contact{
  margin-top: 22px;
  //margin-right: 63px;
  margin-bottom: 24px;
  width:  40%;/*573px;*/
}

.info p {
  font-family: Roboto;
  //max-width: 573px;
  font-style: normal;
  font-weight: bold;
  font-size: 13px;
  line-height: 19px;
  font-feature-settings: 'cpsp' on;
  color: var(--usual-black);
  text-align: left;
}
.contact p {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 13px;
  line-height: 19px;
  font-feature-settings: 'cpsp' on;
  color: var(--usual-black);
  text-align: right;
}
.hover-logout {
  cursor: pointer;
}
.hover-logout img.usr-icon {
  width: 23px;
  height: 23px;
}
.tooltip {
  display: block !important;
  z-index: 10000;
}

.tooltip .tooltip-inner {
  background: var(--middel-grey);
  border: 1px solid var(--middel-grey);
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 19px;
  /* or 146% */
  text-align: center;
  font-feature-settings: 'cpsp' on;
  color: var(--usual-black);
  border-radius: 16px;
  padding: 14px 16px 16px;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border: 1px solid var(--middel-grey);
  position: absolute;
  margin: 5px;
  border-width: 40px;

//border-color: white;
  z-index: 1;
}

.tooltip[x-placement^="top"] {
  margin-bottom: 15px;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 15px 15px 0 15px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -15px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="bottom"] {
  margin-top: 15px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 15px 15px 15px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -15px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="right"] {
  margin-left: 5px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[x-placement^="left"] {
  margin-right: 5px;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip.popover .popover-inner {
  background: var(--toltip-grey);
  color: var(--usual-white);
  padding: 24px;
  border-radius: 5px;
  box-shadow: 0 5px 30px var(--usual-white);
}

.tooltip.popover .popover-arrow {
  border-color: var(--toltip-grey);
}

.tooltip[aria-hidden='true'] {
  visibility: hidden;
  opacity: 0;
  transition: opacity .15s, visibility .15s;
}

.tooltip[aria-hidden='false'] {
  visibility: visible;
  opacity: 1;
  transition: opacity .15s;
}
.logo-mb-menu, .menu-mb, #nav a.logo-menu-link-mob{
  display: none;
}
.header-mob {
  display: none;
  align-items: center;
  justify-content: center;
  background: var(--soft-grey);
  padding: 12px;
}
.links-mob {
  display: flex;
  align-items: center;
  justify-content: center;

}
.links-mob a.usr-link {
  align-items: center;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 19px;
//letter-spacing: 1px;
//text-transform: lowercase;
  text-align: center;
  margin-right: 19px!important;
  color: var(--main-blue);
  display: flex;
  align-items: center;
  cursor: pointer;
}
@media  (max-width: 1040px)  and (orientation: portrait) {
  .header-mob {
    display: flex;
  }
  .router, .user, #nav a.logo-menu-link, .logo-menu, .footer {
    display: none;
  }
  .logo-menu-link-mob, #nav a.logo-menu-link-mob {
    display: block;
  }
  .logo-mb-menu {
    display: block;
    height: 44px;
    width: 164px;
  }
  .menu-mb {
    display: block;
  }
  #nav {
    margin-left: 0;
    margin-right: 0;
    width: 100%;
    justify-content: space-around;
  }
  #app {
    justify-content: start;
  }

}
@media ( max-width: 1040px)  and (orientation: landscape) {
  .header-mob {
    display: flex;
  }
  .router, .user, #nav a.logo-menu-link, .logo-menu, .footer {
    display: none;
  }
  .logo-menu-link-mob, #nav a.logo-menu-link-mob {
    display: block;
  }
  .logo-mb-menu {
    display: block;
    height: 44px;
    width: 164px;
  }
  .menu-mb {
    display: block;
  }
  #nav {
    margin-left: 0;
    margin-right: 0;
    width: 100%;
    justify-content: space-around;
  }
  #app {
    justify-content: start;
  }
}
</style>
